import { FC, ReactNode } from 'react';

import classNames from 'classnames';

type InfoRowProps = {
  icon: FC;
  label: string;
  value?: string;
  children?: ReactNode;
  shouldLineBreakValueDisplayInMobile?: boolean;
  shouldHideOverflow?: boolean;
};

const InfoRow = ({
  icon: Icon,
  label,
  value,
  children,
  shouldLineBreakValueDisplayInMobile,
  shouldHideOverflow,
}: InfoRowProps) => (
  <div
    className={classNames('flex flex-row gap-2', {
      'items-center': !shouldLineBreakValueDisplayInMobile,
      'items-start md:items-center': shouldLineBreakValueDisplayInMobile,
    })}
  >
    <Icon />

    <div
      className={classNames('flex items-center', {
        'flex-col md:flex-row md:gap-1.5': shouldLineBreakValueDisplayInMobile,
        'flex-row gap-1.5': !shouldLineBreakValueDisplayInMobile,
      })}
    >
      <p className="w-max font-bold">{label}</p>

      {value && (
        <p
          title={value}
          className={classNames({
            'md:max-w-full md:text-wrap max-w-28 text-ellipsis overflow-hidden text-nowrap':
              shouldHideOverflow,
          })}
        >
          {value}
        </p>
      )}
    </div>

    {children}
  </div>
);

export default InfoRow;
